module.exports = __webpack_public_path__ + "img/corre.409645b5.png";